import Vue from 'vue'
import Vuex from 'vuex'
import layout from './modules/layout'
import user from './modules/user'
import comm from './modules/comm'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    comm,
    layout,
    user
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js